import { useRef } from "react";
import {
  CheckBox,
  InPlaceDatePickerEditor,
  InPlaceTextEditor,
} from "@etframework/ui.components";
import { useTranslation } from "react-i18next";
import { isTruthyString } from "../../utils/helpers";

export const TaskCustomFieldType = ({
  customField,
  taskCustomField,
  onChange,
  ids,
}) => {
  const { i18n } = useTranslation(["CreateTaskModal"]);
  const value = taskCustomField?.Value;
  const dateRef = useRef(null);

  switch (customField.Type) {
    case 0: // Text
      return (
        <>
          <div className="col-3 fs-14">{customField?.Label}</div>
          <div className="col">
            <InPlaceTextEditor
              name={customField?.Label}
              id={`${ids.customField.textField}-${customField.Id}`}
              value={value}
              change={(e) => {
                e.id = ids.customField.textField;
                e.value = {
                  CustomFieldId: customField.Id,
                  Value: e.value,
                };
                onChange(e);
              }}
            />
          </div>
        </>
      );
    case 1: // Number
      return (
        <>
          <div className="col-3 fs-14">{customField?.Label}</div>
          <div className="col">
            <InPlaceTextEditor
              name={customField?.Label}
              id={`${ids.customField.textField}-${customField.Id}`}
              value={value}
              change={(e) => {
                e.id = ids.customField.textField;
                e.value = {
                  CustomFieldId: customField.Id,
                  Value: e.value,
                };
                onChange(e);
              }}
              type="Numeric"
              model={{
                format: "n",
                decimals: 1,
              }}
            />
          </div>
        </>
      );
    case 2: // Date
      return (
        <>
          <div className="col-3 fs-14">{customField?.Label}</div>
          <div className="col">
            <InPlaceDatePickerEditor
              ref={dateRef}
              id={`${ids.customField.dateField}-${customField.Id}`}
              language={i18n.language}
              value={value}
              submitClick={(e) => {
                e.id = ids.customField.dateField;
                e.value = {
                  CustomFieldId: customField.Id,
                  Value: dateRef?.current?.getValue(),
                };
                onChange(e);
              }}
            />
          </div>
        </>
      );
    case 3: // Checkbox
      return (
        <CheckBox
          id={`${ids.customField.checkboxField}-${customField.Id}`}
          checked={isTruthyString(value)}
          label={customField?.Label}
          change={(e) => {
            e.id = ids.customField.checkboxField;
            e.value = {
              CustomFieldId: customField.Id,
              Value: e.checked,
            };
            onChange(e);
          }}
        />
      );
  }
};
